import './LoadingScreen.css';

function LoadingScreen() {
    return (
        <div className="loading-screen">
            <div className="loading-screen__content">
                <div className="loading-screen__spinner" aria-hidden="true" />
                <span className="loading-screen__brand">SweetMedical</span>
            </div>
        </div>
    );
}

export default LoadingScreen;
